/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_violin_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create a violin plot from grouped data — compare full distributions, no sign-up.`)
};

const es_violin_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crea un gráfico de violín a partir de datos agrupados — compara distribuciones completas, sin registro.`)
};

const de_violin_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erstelle einen Violin-Plot aus gruppierten Daten — vergleiche vollständige Verteilungen, keine Anmeldung nötig.`)
};

const nl_violin_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maak een vioolplot van gegroepeerde gegevens — vergelijk volledige verdelingen, zonder aanmelding.`)
};

const fr_violin_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Créez un graphique en violon à partir de données groupées — comparez des distributions complètes, sans inscription.`)
};

const it_violin_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crea un grafico a violino da dati raggruppati — confronta intere distribuzioni, senza registrazione.`)
};

const pt_br2_violin_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crie um gráfico de violino a partir de dados agrupados — compare distribuições completas, sem cadastro.`)
};

const pt_violin_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crie um gráfico de violino a partir de dados agrupados — compare distribuições completas, sem registo.`)
};

const ja_violin_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`グループ化されたデータからバイオリンプロットを作成 — 分布全体を比較、サインアップ不要。`)
};

const zh_violin_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`根据分组数据创建小提琴图 — 比较完整的分布情况，无需注册。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const violin_tool_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.violin_tool_description(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("violin_tool_description", locale)
	if (locale === "en") return en_violin_tool_description(inputs)
	if (locale === "es") return es_violin_tool_description(inputs)
	if (locale === "de") return de_violin_tool_description(inputs)
	if (locale === "nl") return nl_violin_tool_description(inputs)
	if (locale === "fr") return fr_violin_tool_description(inputs)
	if (locale === "it") return it_violin_tool_description(inputs)
	if (locale === "pt-BR") return pt_br2_violin_tool_description(inputs)
	if (locale === "pt") return pt_violin_tool_description(inputs)
	if (locale === "ja") return ja_violin_tool_description(inputs)
	return zh_violin_tool_description(inputs)
};